import { browserHistory } from 'react-router'
import htmlToDraft from 'html-to-draftjs'
import {
  ContentState,
  EditorState,
} from 'draft-js'

import { getEmails } from 'reduxpath/ducks/Email/List'
import { getEmailById, setData } from 'reduxpath/ducks/Email/Edit'
import { removeEmail } from 'reduxpath/ducks/Email/Remove'
import { getEmailTemplate } from 'reduxpath/ducks/Email/Add'

import Home from 'units/Email'
import List from 'units/Email/units/List'
import Add from 'units/Email/units/Add'
import Edit from 'units/Email/units/Edit'

const list = (store) => {
  store.dispatch(
    getEmails({
      sort: 'name ASC',
      limit: 10,
      skip: 0,
    }),
  )
}

const add = (store) => {
  store.dispatch(getEmailTemplate())
}

const edit = (store, id) => {
  store.dispatch(
    getEmailById(id, (res) => {
      store.dispatch(getEmailTemplate((resTemplate) => {
        const editableContent = res.content
        const lengthString = "<div class='content'>".length
        const contentOnly = editableContent.substring(
          editableContent.lastIndexOf(
            '<div class="content">',
          ) + lengthString,
          editableContent.lastIndexOf('</div>'))
        const contentBlock = htmlToDraft(contentOnly)
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
        const editorState = EditorState.createWithContent(contentState)
        const template = resTemplate.rows[0].content
        const concateTemplate = template.replace(
          '<div class="content">',
          `<div class="content">${contentOnly}`,
        )
        const params = {
          data: {
            id: res.id,
            subject: res.subject,
            category: res.category,
            group: res.group,
            type: res.type,
            template: '',
            content: concateTemplate,
            editor: editorState,
          },
        }
        store.dispatch(setData(params))
      }))
    }),
  )
}

const remove = (store, id) => {
  store.dispatch(
    removeEmail(id, () => {
      browserHistory.push('/emails')
    }),
  )
}

export default {
  populate: {
    list,
    add,
    edit,
    remove,
  },
  components: {
    Home,
    List,
    Add,
    Edit,
  },
}
